import Swal from 'sweetalert2'

export const showError = (text: any) => {
  Swal.fire({
    icon: 'error',
    // title: 'Oops...',
    text: text,
    confirmButtonColor: '#ed2024',
  })
}

export const showSuccess = (text: any) => {
  Swal.fire({
    icon: 'success',
    // title: 'Success',
    text: text,
    confirmButtonColor: '#2eb43a',
  })
}

export const showSuccessWithCallback = (text: any, callback: (result: any) => void) => {
  Swal.fire({
    icon: 'success',
    // title: 'Success',
    text: text,
    confirmButtonColor: '#2eb43a',
  }).then((result) => {
    callback(result)
  })
}

export const showWarning = (text: any) => {
  Swal.fire({
    icon: 'warning',
    // title: 'Success',
    text: text,
    confirmButtonColor: '#d4aa00',
  })
}
